import React from "react";
import { object, string } from "prop-types";

import HorizontalStoryCard from "../horizontal-story-card";
import Headline from "../../atoms/headline";
import "./sidebar-collection.m.css";

const SideBarCollection = ({ collection, storyId }) => {
  const collectionStories = collection.items.filter(item => item.type === "story").slice(0, 4);
  return (
    <div styleName="wrapper">
      <Headline text={collection.name} headerType={8} headerLevel={2} />
      {collectionStories.filter(story => story.id !== storyId).map((item, index) => (
        <HorizontalStoryCard story={item.story} key={index} />
      ))}
    </div>
  );
};

SideBarCollection.defaultProps = {
  collection: {},
  storyId: ""
};

SideBarCollection.propTypes = {
  collection: object,
  storyId: string
};
export default SideBarCollection;
